<script setup lang="ts">
import type { NuxtError } from '#app'

const props = defineProps({
  error: Object as () => NuxtError,
})

onMounted(() => {
  console.error('Error component mounted with error:', props.error)
})

const handleError = () => clearError({ redirect: '/' })
</script>

<template>
    <main
      class="flex-1 h-screen flex flex-col items-center justify-center p-1 ateliers-sans"
    >
      <h1 class="text-md ">
        {{  $t('error.generic') }}
      </h1>

      <button
        @click="handleError"
        class="text-md text-accent hover:text-black"
      >
        {{  $t('error.button.backToHome') }}
      </button>
    </main>
</template>
